import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { MatSliderModule, MatSlider} from '@angular/material/slider';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-slider-range',
  imports: [CommonModule,FormsModule,MatSliderModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderRangeComponent),
      multi: true,
    },
  ],
  templateUrl: './slider-range.component.html',
  styleUrl: './slider-range.component.scss'
})
export class SliderRangeComponent {
  @Input() min: number = 0;
  @Input() max: number = 100000;
  @Input() step: number = 50;
  @Input() label = '';

  value = {
    selectedStipendFrom: this.min,
    selectedStipendUpto: this.max
  };


  @Output() valueChange = new EventEmitter<{
    selectedStipendFrom: number;
    selectedStipendUpto: number;
  }>();

  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(val: { selectedStipendFrom: number; selectedStipendUpto: number }): void {
    if (!val || (val.selectedStipendFrom === 0 && val.selectedStipendUpto === 0)) {
      this.value = {
        selectedStipendFrom: this.min,
        selectedStipendUpto: this.max
      };
    } else {
      this.value = { ...val };
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // implement if needed
  }

  handleChange(): void {
    this.onChange(this.value);
    this.valueChange.emit(this.value);
    this.onTouched();
  }
}
